import translations from "./../data/cgeToBfcTranslations.json";

// For each cgeProperty, if the property is in the imported list of translations,
// translate it the to the corresponding bfcProperty
// e.g. 'FrameType' can be translated to 'type'

export default function transformCgeToBfcProperties(cgeProperties) {
  const bfcProperties = {};

  Object.keys(translations).forEach(translation => {
    const cgeKey = translation;
    const value = cgeProperties[cgeKey];

    if (value) {
      const bfcKey = translations[cgeKey];

      bfcProperties[bfcKey] = value;
    }
  });

  return bfcProperties;
}
